export default "__VITE_ASSET__5AkXa2W4__"